import ImageWithBasePath from "@/components/image-with-base-path"
import { all_routes } from "@/routes/all_routes"
import { Link } from "react-router"


const FooterSection = () => {
  return (
<>
  {/* footer section start */}
  <footer className="footer footer-fourteen">
    <div className="container">
      <div className="animated-text">DOCCURE</div>
    </div>
    <div className="footer-top">
      <div className="container">
        {/* start row */}
        <div className="row g-4">
          {/*  Menu 1 */}
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6">
            <div className="footer-widget mt-0">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-menu">
                <li>
                  <Link to={all_routes.home}>Home</Link>
                </li>
                <li>
                  <Link to={all_routes.aboutUs}>About Us</Link>
                </li>
                <li>
                  <Link to={all_routes.speciality}>Specialities</Link>
                </li>
                <li>
                  <Link to={all_routes.doctorProfile1}>Doctors</Link>
                </li>
                <li>
                  <Link to={all_routes.contactUs}>Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>
          {/*  Menu 2 */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="footer-widget">
              <h3 className="footer-title">Contact</h3>
              <div className="footer-contact">
                <h4>Call / Email</h4>
                <p>
                  <Link to="tel:+12456589856">+1 24579 54581</Link>
                </p>
                <p>
                  <Link to="mailto:info@example.com">info@example.com</Link>
                </p>
              </div>
              <div className="footer-contact">
                <h4>Our Address</h4>
                <p>8432 Mante Highway, Aminaport, USA, IC410</p>
              </div>
            </div>
          </div>
          {/*  Menu 5 */}
          <div className="col-xl-5 offset-xl-2 col-lg-6 col-md-12 col-sm-12">
            <div className="footer-widget footer-join">
              <h4>Join our Community</h4>
              <p>
                Get the latest news, offers, and insights delivered straight to
                your inbox.
              </p>
              <div className="subscribe-input">
                <form action="#">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email Address"
                  />
                  <button
                    type="submit"
                    className="btn-icon btn btn-secondary"
                    aria-label="search"
                  >
                    <i className="isax isax-arrow-right-1" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* end row */}
      </div>
    </div>
    <div className="container">
      <div className="footer-bottom">
        <div className="footer-links">
          <Link to={all_routes.home}>
            <ImageWithBasePath
              src="assets/img/logo-white-14.svg"
              alt="logo"
              className="img-fluid"
            />
          </Link>
          <ul className="social-icon">
            <li>
              <Link to="#" aria-label="facebook">
                <i className="fa-brands fa-facebook" />
              </Link>
            </li>
            <li>
              <Link to="#" aria-label="twitter">
                <i className="fa-brands fa-x-twitter" />
              </Link>
            </li>
            <li>
              <Link to="#" aria-label="instagram">
                <i className="fa-brands fa-instagram" />
              </Link>
            </li>
            <li>
              <Link to="#" aria-label="linkedin">
                <i className="fa-brands fa-linkedin" />
              </Link>
            </li>
          </ul>
        </div>
        {/* start row */}
        <div className="row g-3 align-items-center">
          <div className="col-xl-6 col-md-7">
            <p>
              Copyright © 2026 <Link to={all_routes.home}>Doccure</Link>. All Rights
              Reserved
            </p>
          </div>
          <div className="col-xl-6 col-md-5">
            <ul className="policy-links">
              <li>
                <Link to={all_routes.termsAndCondition}>Terms &amp; Condition</Link>
              </li>
              <li>
                <Link to={all_routes.privacyPolicy}>Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>
        {/* end row */}
      </div>
    </div>
    <ImageWithBasePath
      src="assets/img/bg/footer-bg-15.png"
      alt="footer"
      className="img-fluid footer-bg"
    />
    <ImageWithBasePath
      src="assets/img/bg/footer-bg-16.png"
      alt="footer"
      className="img-fluid footer-bg-02"
    />
  </footer>
  {/* footer section end */}
</>


  )
}

export default FooterSection